export const NUM_CURATED_TRAILS = 400; // thousand
export const NUM_USERS = 60; // million
export const LOGGED_DISTANCE = 1.609344e12; // meters
